<template>
	<div v-if="phase=='edit'" class="col-md-6 offset-md-3 card p-3 noborder">
		<h2>Konferencia adatok</h2>
		<div class="border border-primary card p-3 bg-light">
			<div class="form-group">
				<label for="intezmenyKod">Intézmény</label>
				<select v-model="jegyzokonyv.intezmenyKod" class="form-control" required>
					<option value=""></option>
					<option v-for="(intezmeny) in this.intezmenyek" :value="intezmeny.kod">{{ intezmeny.nev }}</option>
				</select>
			</div>
			<div class="form-group">
				<label for="karKod">Kari szintű egység <i>(továbbiakban kar)</i></label>
				<select v-model="jegyzokonyv.karKod" class="form-control">
					<option value=""></option>
					<option v-for="(kar) in this.availableKar()" :value="kar.kod">{{ kar.nev }}</option>
				</select>
			</div>
			<div class="form-group">
				<label for="tanszek">Tanszék</label>
				<input type="text" id='tanszek' v-model.trim="jegyzokonyv.tanszek" class="form-control">
			</div>
			<div class="form-group">
				<label for="muhely">TDK műhely</label>
				<input type="text" id='muhely' v-model.trim="jegyzokonyv.muhely" class="form-control">
			</div>
			<div class="form-group">
				<label for="konferencia">Intézményi TDK-konferencia  belső elnevezése</label>
				<input type="text" id='konferencia' v-model.trim="jegyzokonyv.konferencia" class="form-control" required>
			</div>
			<div class="form-group">
				<label for="idopont">Konferencia időpontja</label>
				<input type="date" id='idopont' v-model="jegyzokonyv.idopont" class="form-control" required>
			</div>
			<div class="form-group">
				<label for="helyszin">Konferencia helyszíne</label>
				<input type="text" id='helyszin' v-model.trim="jegyzokonyv.helyszin" class="form-control" required>
			</div>
			<div class="form-group">
				<label for="szekcio">OTDK szekció <i>(amennyiben várhatóan minden pályamunka ugyanabba a szekcióba lesz nevezve)</i></label>
				<input type="text" id='szekcio' v-model.trim="jegyzokonyv.szekcio" class="form-control">
			</div>
		</div>

		<h2>Zsűritagok</h2>
		<div class="border border-primary card p-3 bg-light">
			<zsuritag v-for="(zsuritag, index) in jegyzokonyv.zsuritagok" :zsuritag="zsuritag" :jegyzokonyv="jegyzokonyv" :index="index" />
			<button class="btn btn-primary btn-narrow" @click.prevent="addZsuritag">Zsűritag felvétele</button>
		</div>
		<h2>Pályamunkák</h2>
		<palyamunka v-for="(palyamunka, index) in jegyzokonyv.palyamunkak" :palyamunka="palyamunka" :jegyzokonyv="jegyzokonyv" :index="index" />
		<button class="btn btn-primary" @click.prevent="addPalyamunka">Pályamunka felvétele</button>
	</div>

	<div v-if="phase=='print'">
		<h2 class="text-center">TDK konferencia jegyzőkönyv</h2>
		<div class="col-md-8 offset-md-2 mt-5">
			<div class="child container-xxl">
				<div class="row">
					<div class="col-sm-1 text-header">
						Intézmény:
					</div>
					<div class="col-sm-3">
						<span class="jktext">{{ jegyzokonyv.intezmenyKod }} </span>
					</div>
					<div class="col-sm-1 text-header">
						Belső elnevezés:
					</div>
					<div class="col-sm-6">
						<span class="jktext">{{ jegyzokonyv.konferencia }} </span>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-1 text-header">
						Kar:
					</div>
					<div class="col-sm-3">
						<span class="jktext">{{ jegyzokonyv.karKod }} </span>
					</div>
					<div class="col-sm-1 text-header">
						Szekció:
					</div>
					<div class="col-sm-6">
						<span class="jktext">{{ jegyzokonyv.szekcio }} </span>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-1 text-header">
						Tanszék:
					</div>
					<div class="col-sm-3">
						<span class="jktext">{{ jegyzokonyv.tanszek }} </span>
					</div>
					<div class="col-sm-1 text-header">
						Helyszín:
					</div>
					<div class="col-sm-6">
						<span class="jktext">{{ jegyzokonyv.helyszin }} </span>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-1 text-header">
						TDK műhely:
					</div>
					<div class="col-sm-3">
						<span class="jktext">{{ jegyzokonyv.muhely }} </span>
					</div>
					<div class="col-sm-1 text-header">
						Időpont:
					</div>
					<div class="col-sm-6">
						<span class="jktext">{{ jegyzokonyv.idopont }} </span>
					</div>
				</div>
			</div>
		</div>

		<table class="table table-bordered" style="margin-top: 20px;">
			<thead>
				<tr>
					<th class="text-center" scope="col">
						#
					</th>
					<th class="text-center" scope="col">
						Szerző(k) neve
					</th>
					<th class="text-center" scope="col">
						Pályamunka címe
					</th>
					<th class="text-center" scope="col">
						Témavezető(k) neve
					</th>
					<th class="text-center" scope="col">
						Összesített<br />pontszám
					</th>
					<th class="text-center" scope="col">
						Helyezés
					</th>
					<th class="text-center" scope="col">
						Zsűri megjegyzése
					</th>
					<th class="text-center" scope="col">
						OTDK-ra javasolt
					</th>
				</tr>
			</thead>
			<tbody>
				<palyamunka v-for="(palyamunka, index) in jegyzokonyv.palyamunkak" :palyamunka="palyamunka" :index="index" :print="true" />
			</tbody>
		</table>
		<div style="min-height: 50px" />
		<table align="center">
			<tbody>
				<tr>
					<zsuritag v-for="(zsuritag, index) in jegyzokonyv.zsuritagok" :zsuritag="zsuritag" :jegyzokonyv="jegyzokonyv" :index="index" :print="true" />
				</tr>
			</tbody>
		</table>
	</div>

	<div v-if="phase=='validate'" class="col-md-6 offset-md-3 mt-5 card p-3">
		<div v-if="this.$storage.isValid()" class="border border-primary card p-3 bg-light">
			<h2>Véglegesítés</h2>
			<div class="alert alert-success">Az automatikus validáció nem talált hibákat.</div>
			<button class="btn btn-primary m-1" @click.prevent="saveValidatedJegyzokonyvXml" type="button">Véglegesített jegyzőkönyv letöltése</button>
		</div>
		<div v-if="!this.$storage.isValid()" class="border border-primary card p-3 bg-light">
			<h2>Automatikus validáció eredménye</h2>
			<div>Az automatikus validáció az alábbi hibákat tárta fel. A jegyzőkönyv véglegesítése (és a végleges XML állomány letöltése) csak a hibák kijavítását követően lehetséges.</div><br />
			<div v-for="(text) in this.$storage.validationDetails()" class="alert alert-danger">{{ text }}</div>
		</div>
	</div>
</template>

<script>
import Palyamunka from './Palyamunka.vue'
import Zsuritag from './Zsuritag.vue'

export default {
   	components: {
		Palyamunka, Zsuritag
	},
	data() {
		return {
			jegyzokonyv: null,
			phase: 'edit',
            intezmenyek: []
		}
	},
    async created() {
		this.jegyzokonyv = this.$storage.getJegyzokonyv(this.$app_name);
        this.intezmenyek = await this.$storage.getIntezmenyekKonferencia();
        this.$forceUpdate();
    },
	methods: {
		addPalyamunka() {
			this.$storage.createPalyamunka(this.jegyzokonyv);
		},
        addZsuritag() {
            this.$storage.createZsuritag(this.jegyzokonyv);
        },
		availableKar() {
			var intezmenyKod = this.jegyzokonyv.intezmenyKod;
			var intezmenyObj = this.intezmenyek.find((x) => x.kod == intezmenyKod);
            if (intezmenyObj)
                return intezmenyObj.karok;
            else
                return this.intezmenyek;
		},
        saveValidatedJegyzokonyvXml() {
            var xmlString = this.$storage.saveJegyzokonyvXml(true);

            const blob = new Blob([xmlString], { type: 'application/xml' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = this.$storage.filename();
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        },
	}
}
</script>

<style>

    @media print {
        @page {
            size: A4 landscape;
            margin: 0;
        }
        body {
            margin: 1.6cm;
            zoom: 70%;
        }
    }

    .bg-light {
        background-color: #fafafa !important;
    }

	.noborder {
		border: none;
	}

    .card-header {
        background-color: transparent !important;
        font-family: font-family Roboto, sans-serif;
        font-style: italic;
        font-size: 24px;
        margin: 0px 0px 0px 0px;
        padding: 0px 0px 0px 10px;
    }

    .card-separator {
        font-family: font-family Roboto, sans-serif;
        font-style: italic;
        font-size: 18px;
        font-weight: 600;
        border-bottom: 1px solid rgba(0, 0, 0, 0.17);
		margin-bottom: 5px;
    }

    .card {
    }

    .row-icon-delete {
        position: absolute;
        right: 15px;
        width: 20px;
        height: 20px;
        padding: 0;
        background-color: white;
        background-image: url('@/assets/trash3.svg');
        background-size: 100% 100%;
        opacity: 0.5;
        border: none;
    }

    .x-icon-delete {
        position: absolute;
        top: 12px;
        right: 15px;
        width: 20px;
        height: 20px;
        padding: 0;
        background-color: white;
        background-image: url('@/assets/trash3.svg');
        background-size: 100% 100%;
        opacity: 0.5;
        border: none;
    }

    .x-icon-up {
        position: absolute;
        top: 12px;
        right: 40px;
        width: 20px;
        height: 20px;
        padding: 0;
        background-color: white;
        background-image: url('@/assets/arrow-up-square.svg');
        background-size: 100% 100%;
        color: black;
        opacity: 0.5;
        border: none;
    }

    .x-icon-down {
        position: absolute;
        top: 12px;
        right: 65px;
        width: 20px;
        height: 20px;
        padding: 0;
        background-color: white;
        background-image: url('@/assets/arrow-down-square.svg');
        background-size: 100% 100%;
        color: black;
        opacity: 0.5;
        border: none;
    }

    input:invalid {
        background: #fce8e8;
    }

    select:invalid {
        background: #fce8e8;
    }

    h2 {
        font-family: Poppins, sans-serif;
        font-size: 32.4px;
        font-style: normal;
        font-weight: 500;
        margin-top: 50px;
    }

    h2:first-child {
        margin-top: 0px;
    }

    div {
        font-family: Roboto, sans-serif;
        font-size: 18px;
        font-weight: 300;
		margin-top: 5px;
    }

    div:first-child {
        margin-top: 0px;
    }

    .border {
        border-color: red !important;
        border-width: 2px !important;
    }

    th[scope=col] {
        font-family: Roboto, sans-serif;
        font-size: 14px;
        font-weight: 100;
		text-align: center;
    }

    .btn-narrow {
        margin-left: 50px;
        margin-right: 50px;
    }

    .text-header {
        font-size: 16px;
        width: 12%;
    }
</style>